import { createReducer } from '../../utilities';
import {
    REQUEST_FETCH_STATS_PLATFORMS,
    SUCCESS_FETCH_STATS_PLATFORMS,
    FAIL_FETCH_STATS_PLATFORMS,
} from "../../../actions/entities/statistics/platforms";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_PLATFORMS]: requestFetch,
    [SUCCESS_FETCH_STATS_PLATFORMS]: successFetch,
    [FAIL_FETCH_STATS_PLATFORMS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/platforms.js